<script setup>
import { computed } from "vue"
import { storage } from '../../storage'
const props = defineProps(['alien'])

function getUrl(type) {
    const url = `/spacebar-clicker/assets/aliens/${type}.png`
    return url
}

const animationType = computed(() => {
    let theClass = `alien-${props.alien.id} `
    if (props.alien.id % 5 === 0)
        theClass += 'fifth-type'
    else if (props.alien.id % 3 === 0)
        theClass += 'third-type'
    else if (props.alien.id % 4 === 0)
        theClass += 'forth-type'
    else if (props.alien.id % 2 === 0)
        theClass += 'second-type'
    else
        theClass += 'first-type'
    return theClass
})

const hasGlasses = computed(() => {
    return storage.UPGRADES_LVLS.alienBoost[props.alien.id] > 0
})

</script>

<template>
    <div class="alien-img" :class="animationType" v-show="alien.amount > 0">
        <img :src="getUrl(alien.imgSrc)" alt="" >
        <img v-if="hasGlasses" class="mini-glasses" :class="[`glasses-${storage.UPGRADES_LVLS.alienBoost[alien.id]}`]" 
            :src="`/spacebar-clicker/assets/glasses/glasses${storage.UPGRADES_LVLS.alienBoost[alien.id]}.png`"
            alt="glasses">
    </div>
</template>

<style scoped>
.alien-img {
    position: absolute;
    background-color: transparent;
    width: 45px;
    overflow: visible;
}

.alien-img img.mini-glasses {
    position: absolute;
    width: 90%;
    top: 28%;
    left: 8%;
    /* transform: translateX(-50%); */
    z-index: 100;
}

.alien-img img.mini-glasses.glasses-5 {
    top: 18%;
}

.alien-img.alien-4 img.mini-glasses {
    left: 0;
}

.alien-img.alien-4 img.mini-glasses.glasses-4 {
    top: 30%;
}

.alien-img.alien-8 img.mini-glasses.glasses-4 {
    left: 4%;
}

.alien-img.alien-1 img.mini-glasses {
    top: 30%;
    left: 3%;
}

.alien-img.alien-6 img.mini-glasses {
    top: 32%;
}

.alien-img.alien-6 img.mini-glasses.glasses-2 {
    top: 36%;
}

.alien-img img.mini-glasses.glasses-2 {
    top: 34%;
}

.alien-img.alien-12 img.mini-glasses {
    left: 13%;
    top: 22%;
    transform: rotate(353deg);
}

.alien-img.alien-12 img.mini-glasses.glasses-2 {
    top: 28%;
}

.alien-img.alien-12 img.mini-glasses.glasses-5 {
    top: 16%;
}

.alien-img.alien-1 {
    left: 50%;
    bottom: 50%;
    animation-delay: -2s !important;
}

.alien-img.alien-2 {
    left: 10%;
    bottom: 25%;
}

.alien-img.alien-3 {
    left: 30%;
    bottom: 5%;
    animation-delay: 300ms !important;
}

.alien-img.alien-4 {
    left: 50%;
    top: 50%;
    animation-delay: 500ms !important;
}

.alien-img.alien-5 {
    left: 60%;
    top: 60%;
    animation-delay: 700ms !important;
}

.alien-img.alien-6 {
    left: 70%;
    bottom: 5%;
    animation-delay: 1s !important;
}

.alien-img.alien-7 {
    left: 65%;
    bottom: 5%;
    animation-delay: 1500ms !important;
}

.alien-img.alien-8 {
    left: 60%;
    bottom: 20%;
    animation-delay: 1200ms !important;
}

.alien-img.alien-9 {
    left: 35%;
    bottom: 40%;
    animation-delay: 2ms !important;
}

.alien-img.alien-10 {
    left: 30%;
    bottom: 25%;
    animation-delay: 300ms !important;
}

.alien-img.alien-11 {
    left: 15%;
    bottom: 5%;
    animation-delay: 800ms !important;
}

.alien-img.alien-12 {
    left: 50%;
    bottom: 50%;
    animation-delay: 300ms !important;
}

.alien-img.first-type {
    animation: moveTrio 5s infinite linear;
}

.alien-img.second-type {
    animation: moveWave 8s infinite alternate linear;
}

.alien-img.third-type {
    animation: moveTrio2 infinite linear;
    animation-duration: 8s;
    animation-direction: reverse;
}

.alien-img.forth-type {
    animation: moveCircle 10s infinite linear;
    animation-direction: reverse;
}

.alien-img.fifth-type {
    animation: moveCircle 10s infinite linear;
}


@keyframes moveCircle {
    0% {
        transform: translate(-50%, -50%) rotate(0deg) translate(60px, 0) rotate(0deg);
    }

    100% {
        transform: translate(-50%, -50%) rotate(360deg) translate(60px, 0) rotate(-360deg);
    }
}

@keyframes moveCircleMini {
    0% {
        transform: translate(-50%, -50%) rotate(0deg) translate(30px, 0) rotate(0deg);
    }

    100% {
        transform: translate(-50%, -50%) rotate(360deg) translate(30px, 0) rotate(-360deg);
    }
}

@keyframes moveTrio {
    0% {
        transform: translate(0, 0) translate(0, 0);
    }

    33% {

        transform: translate(50%, -50%) translate(30px, -30px);
    }

    66% {
        transform: translate(-50%, -50%) translate(-30px, -30px);
    }

    100% {
        transform: translate(0, 0) translate(0, 0);
    }
}

@keyframes moveTrioMini {
    0% {
        transform: translate(0, 0);
    }

    33% {

        transform: translate(15px, -20px);
    }

    66% {
        transform: translate(-15px, -20px);
    }

    100% {
        transform: translate(0, 0);
    }
}

@keyframes moveTrio2 {
    0% {
        transform: translate(0, 0);
    }

    33% {

        transform: translate(60px, -50px);
    }

    66% {
        transform: translate(-60px, -50px);
    }

    100% {
        transform: translate(0, 0);
    }
}

@keyframes moveWave {
    0% {
        transform: translate(0, 0);
    }

    20% {
        transform: translate(60px, -25px);
    }

    40% {
        transform: translate(120px, 25px);
    }

    60% {
        transform: translate(180px, -25px);
    }

    80% {
        transform: translate(240px, 25px);
    }

    100% {
        transform: translate(300px, -25px);
    }
}

@keyframes moveWaveMini {
    0% {
        transform: translate(0, 0);
    }

    20% {
        transform: translate(30px, -20px);
    }

    40% {
        transform: translate(60px, 20px);
    }

    60% {
        transform: translate(120px, -20px);
    }

    80% {
        transform: translate(180px, 20px);
    }

    100% {
        transform: translate(240px, -20px);
    }
}

.alien-img img {
    position: relative;
    background-color: transparent;
    width: 100%;
}


@media screen and (max-height:550px) {
    /* @media screen and (max-width: 1000px) and (max-height:550px) { */

    .alien-img {
        width: 30px;
    }

    .alien-img.alien-5 {
        left: 60%;
        top: 40%;
    }

    .alien-img.alien-6 {
        left: 60%;
    }

    .alien-img.alien-9 {
        left: 30%;
        bottom: 10%;
    }

    .alien-img.alien-12 {
        left: 45%;
        bottom: 30%;
    }

    .alien-img.first-type {
        animation-name: moveTrioMini;
    }

    .alien-img.second-type {
        animation-name: moveWaveMini;
    }

    .alien-img.forth-type {
        animation-name: moveCircleMini;
    }

    .alien-img.fifth-type {
        animation-name: moveCircleMini;
    }

    /* .alien-img.third-type {
        animation: moveTrio2Mini infinite linear;
        animation-duration: 8s;
        animation-direction: reverse;
    }

  

    .alien-img.fifth-type {
        animation: moveCircleMini 10s infinite linear;
    } */

}
</style>